import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { nativeStcPayload } from '~/native/home/utils';
import {
  MainContentBoldText,
  MainContentHeader,
  StatusPill
} from './DynamicPromoTile.styles';
import {
  getDynamicTilePillText,
  getPillColorScheme,
  TileStatus
} from '../TileUtils';

const TradeInfo = ({ tileStatus, tileType }) => {
  const { statusAgnosticTrade } = useContext(TradeContext);

  if (!statusAgnosticTrade) return null;

  const {
    acquisitionName,
    year,
    make,
    model,
    vehicleValue = 0,
    vehicleImages
  } = statusAgnosticTrade;

  const pillClassName = getPillColorScheme(tileStatus);
  const pillText = getDynamicTilePillText({ tileStatus, tileType });
  const vehicleImageClassName = 'absolute right-[-20px] w-[130px] m:w-[166px]';
  const tradeInValueCopy =
    vehicleValue > 0 ? `$${vehicleValue.toLocaleString()}` : 'TBD';

  return (
    <>
      <MainContentHeader>
        <StatusPill className={pillClassName}>{pillText}</StatusPill>
        <MainContentBoldText>
          {year} {make} {model}
        </MainContentBoldText>
      </MainContentHeader>
      <section className="relative flex items-center">
        <div className="flex flex-col gap-4">
          <span className="text-xs font-semibold text-grey-5 ">
            TRADE-IN-VALUE
          </span>
          <span className="text-[28px] font-semibold leading-[32px] text-blue-6">
            {tradeInValueCopy}
          </span>
        </div>
        <img
          className={vehicleImageClassName}
          src={vehicleImages.mobileImage}
        />
      </section>
      {tileStatus !== TileStatus.isExpired &&
        tileStatus !== TileStatus.isPending && (
          <a
            href={`/sell-my-car/hub/${acquisitionName}`}
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify({
              description: `${tileType} tile acquisition cta`,
              acquisitionName,
              year,
              make,
              model,
              vehicleValue
            })}
            data-qa={`${tileType} view offer details link`}
            className="text-sm text-blue-6 underline"
            data-native-payload={nativeStcPayload}
          >
            View offer details
          </a>
        )}
    </>
  );
};

export default TradeInfo;
